<!--
 * @Author: FengXiao
 * @Date: 2020-07-14 15:10:28
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 00:48:24
-->
<template>
  <div class="speech-detail-page page-container">
    <video-player :datas="videoData" :speaker="speaker" :allowEvent.sync="playerAllowEvent"
      :viplock="vip_lock"></video-player>
    <div class="content">
      <div class="speechother">
        <episode-list :title="topic.title" :datas="episodeList" :init-slide="initSlide" v-if="episodeList.length"
          @select="onSelectEpisode"></episode-list>
      </div>
      <div class="speechContent" :class="{ 'no-recommend': !recommendList.length }">
        <div class="left-bl clearfix">
          <h1 class="detail_title">{{ topic.title }}</h1>
          <div class="detail_meta" v-if="detailMeta">{{ detailMeta }}</div>
          <transition name="el-fade-in-linear">
            <!-- 隐私改版：移除评论区，文稿常驻展示；无文稿时显示占位提示 -->
            <div v-if="draft" key="draft" class="child-bl" v-html="draft"></div>
            <div v-else key="empty" class="draft-empty">本篇暂无文稿</div>
          </transition>
        </div>
        <div class="right-bl">
          <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import 'element-ui/lib/theme-chalk/base.css';
import RecommendVideos from '@/components/AppRecommendVideos';
import requestApi from '@/service';
import EpisodeList from '@/components/AppEpisodeList';

import configFields from '@/utils/configFields';
const { DRAFT_TYPE } = configFields;
export default {
  name: 'SpeechDetail',
  components: {
    VideoPlayer,
    RecommendVideos,
    EpisodeList,
  },
  data() {
    return {
      videoData: {},
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      speaker: {},
      recommendList: [],
      topic: {},
      draft: '',
      speechId: '',
      videotype: '',
      episodeList: [],
      vip_lock: false,
    };
  },
  mounted() {
    this.init();
    this.getDarft(true); // 隐私改版：文稿常驻展示，进入页面即加载
  },
  watch: {
    $route(to) {
      if (to.path === '/speech/detail') {
        this.init();
        this.draft = '';
        this.getDarft(true); // 隐私改版：切换视频时文稿跟随刷新
      }
    },
  },
  computed: {
    detailMeta() {
      // 讲者 · 城市 · 日期
      return [this.speaker && this.speaker.name, this.topic.city, this.topic.date].filter(Boolean).join(' · ');
    },
    initSlide() {
      let index = 0;
      for (let i = 0; i < this.episodeList.length; i++) {
        if (this.episodeList[i].id === this.speechId) {
          index = i;
          break;
        }
      }
      return index;
    },
  },
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
      this.speechId = +this.$route.query.id;
      this.videotype = +this.$route.query.videotype;
      // this.getDetail();
      this.getspeechDetail();
      this.getRecommend();
      this.initScrollTop();
    },
    getspeechDetail() {
      requestApi('/v3/api/h5/play_detail/',
        {
          video_type: this.videotype || "0",
          video_id: this.speechId,
          album_id: 0,
        },
        'GET').then(res => {
          if (res.base_items.member_type == 2) {
            // 隐私改版：付费内容一律上锁，引导下载一席App观看
            this.vip_lock = true
          }
          // 使用 map 方法替换 video_url 中的 http:// 为 https://
          const updatedVideoUrls = res.base_items.video_url.map(item => {
            if (item.video_url) {
              item.video_url = item.video_url.replace('http:', 'https:');
            }
            return item;
          });

          this.episodeList = res.speech_choice_items
          this.speaker = res.base_items.speaker;
          this.videoData = {
            cover: res.base_items.video_cover,
            videoUrls: updatedVideoUrls,
            intro: res.base_items.intro,
            member_type: res.base_items.member_type,
          };
          this.topic = {
            title: res.base_items.title,
            category: res.base_items.videocate_items[0],
            date: res.base_items.created,
            city: res.base_items.city,
            intro: res.base_items.intro,
          };
          document.title = `${res.base_items.title} - 一席`;
        })
    },
    getDetail() {
      const url = `/v3/api/site/speech/${this.speechId}/detail/`;
      requestApi(url).then(({ speech }) => {
        const { speaker, video_url, cover, titlelanguage, title, first_category, date, city, audio_duration, audio_url } = speech;
        this.speaker = speaker;
        this.videoData = {
          cover,
          videoUrls: video_url,
          intro: titlelanguage,
        };
        this.topic = {
          title,
          category: first_category,
          date,
          city,
          intro: titlelanguage,
        };
        document.title = `${title} - 一席`;
        this.audioData = {
          duration: audio_duration,
          url: audio_url,
        };
      });
    },
    getRecommend() {
      const url = `/v3/api/site/speech/${this.speechId}/recommend/`;
      requestApi(url).then(({ recommended }) => {
        if (recommended && recommended.length) {
          this.recommendList = recommended.map(item => {
            item.category = item.first_category;
            return item;
          });
        } else {
          this.recommendList = [];
        }
      });
    },
    /**
     * @description: 获取演讲稿
     */
    getDarft(silent = false) {
      return new Promise(resolve => {
        requestApi('/v3/api/site/draft/', {
          id: this.speechId,
          type: DRAFT_TYPE.speech,
        }).then(({ draft }) => {
          if (draft) {
            this.draft = draft;
            resolve(true);
          } else {
            if (!silent) this.$message.error('未找到文稿');
            resolve(false);
          }
        });
      });
    },
    onClickRecommend(id) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id,
        },
      });
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
    onSelectEpisode(data) {
      this.gotoSpeechother(data.id, data.video_type)
    },
    gotoSpeechother(id, videotype) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id,
          videotype,
        },
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.speech-detail-page {
  .detail_title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    line-height: 1.5;
    margin: 28px 0 8px;
  }

  .detail_meta {
    font-size: 14px;
    color: #999;
    line-height: 1.5;
    margin: 0 0 20px;
  }

  .speechContent {
    // 无推荐内容时左栏撑满整行
    &.no-recommend {
      .left-bl {
        width: 100%;
        max-width: 100%;
      }
      .right-bl {
        display: none;
      }
    }
    display: flex;
    align-items: flex-start;
    margin: 20px auto 100px;

    .left-bl {
      width: 72%;
      max-width: 827px;
      margin-right: 10px;
      box-sizing: border-box;
      background: $C1;
      padding: 0 40px;
      position: relative;

      .child-bl {
        float: left;
        left: 0;
        top: 0;
        width: 100%;
      }
    }

    .right-bl {
      width: 28%;
      background-color: $C10;
    }
  }
}

.draft-empty {
  padding: 80px 0;
  text-align: center;
  font-size: 14px;
  color: #999999;
}
</style>
